var _path, _path2, _path3, _path4, _path5, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 183,
    height: 87,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 67c0 5-2 10-6 14s-10 6-15 6c-6 0-12-2-16-6s-6-9-6-14c0-6 2-11 6-15s10-6 16-6c5 0 11 2 15 6s6 9 6 15Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43 6v62h-8V6h8Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M35 3a2 2 0 0 1 1-2 3 3 0 0 1 2-1c13 1 14 7 27 7l2 1 1 2v13a2 2 0 0 1-1 2 3 3 0 0 1-2 1c-13-1-14-7-27-8h-2l-1-2V3ZM153 67c0 5-2 10-6 14s-10 6-15 6c-6 0-12-2-16-6s-6-9-6-14c0-6 2-11 6-15s10-6 16-6c5 0 11 2 15 6s6 9 6 15Z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M153 6v62h-8V6h8Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145 3a2 2 0 0 1 1-2 3 3 0 0 1 2-1c13 1 14 7 27 7l2 1 1 2v13a2 2 0 0 1-1 2 3 3 0 0 1-2 1c-13-1-14-7-27-8h-2l-1-2V3Z",
    fill: "#fff"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 182.1,
    y: 72.1,
    width: 12,
    height: 93.5,
    rx: 2,
    transform: "rotate(135 182 72)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioIcon);
export default __webpack_public_path__ + "static/media/radio-icon.d579da2a6e86f82e33b20073b6f9eb0b.svg";
export { ForwardRef as ReactComponent };